export const environment = {
    production: true,
    turnstileSiteKey: '0x4AAAAAAEFE86Z1G1Hkscnb',
    sentry_env: 'production',
    bamboo_build_nr:"375"
};
